import { Link } from "react-router-dom";

import { useState } from "react";
import { Col, Row } from "../../ApiS/Grid-system/Grid-system";
import Input from "../Inputs/Input";
import MainButton from "./MainButton";

interface AddResultProps {
  link?: string;
  check?: boolean;
  enter_result?: () => void;
}

const AddResult: React.FC<AddResultProps> = ({ link, check, enter_result }) => {
  const [popup, setpopup] = useState(false);

  return (
    <>
      <Link to={link || ""}>
        <div
          className={`flex z-10 justify-center  items-center fixed bottom-10 left-5 font-bold text-5xl bg-Secondary text-white cursor-pointer w-14 h-14 rounded-full`}
          onClick={() => setpopup(!popup)}
        >
          <span className="mb-3">+</span>
        </div>
      </Link>

      {popup && (
        <Row className="">
          <Col
            lg={12}
            className="h-[100vh]    w-full flex z-50 justify-center items-center fixed top-0 right-0 font-bold  !bg-black !bg-opacity-50  "
          >
            <Row
              justify={"start"}
              className="relative bg-white w-[400px]   border-2 border-white rounded-lg"
            >
              <div
                className="absolute cursor-pointer top-5   hover:text-white text-Secondary hover:transition-all flex items-center justify-start   "
                onClick={() => setpopup(!popup)}
              >
                <span className="hover:bg-red-600 bg-gray-100 absolute px-3 py-1 text-2xl flex justify-center items-center rounded-full ">
                  X
                </span>
              </div>

              <Row justify={"center"} className="!mt-8 ">
                <Col lg={6} sm={10}>
                  <Input placeholder=" اسم الطالب ونسبته " />
                </Col>
                <Col lg={6} sm={10}>
                  <Input placeholder=" اسم الاب " />
                </Col>
                <Col lg={6} sm={10}>
                  <Input placeholder=" اسم الام " />
                </Col>
                <Col lg={6} sm={10}>
                  <Input placeholder=" العلامة رقما " />
                </Col>
                <Col lg={6} sm={10}>
                  <Input placeholder=" العلامة كتابتا " />
                </Col>
                <Col lg={6} sm={10}>
                  <Input placeholder=" النتيجة " />
                </Col>
              </Row>

              <Col className="flex justify-evenly !mt-4 ">
                <Col lg={3} md={5} sm={4}>
                  <MainButton titlebtn="اضافة" className="w-full" />
                </Col>
                <Col lg={3} md={5} sm={4}>
                  <MainButton
                    titlebtn="الغاء"
                    className="w-full !bg-gray-200 !text-Secondary"
                    onClick={() => setpopup(!popup)}
                  />
                </Col>
              </Col>
            </Row>
          </Col>
        </Row>
      )}
    </>
  );
};

export default AddResult;
